import { render, staticRenderFns } from "./SpacerWidget.vue?vue&type=template&id=74e196a0&scoped=true&"
import script from "./SpacerWidget.vue?vue&type=script&lang=js&"
export * from "./SpacerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e196a0",
  null
  
)

export default component.exports